import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useSubcategoryStore } from "../../../hooks/useSubcategoryStore";
import { useSpecificSubcategoryStore } from "../../../hooks/useSpecificSubcategoryStore";

type Values = {
    id: number,
    name: string,
    description: string,
    idspecificsubcategories: string,
    status: string,
}

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align:'center' },
];

export const SubcategoryModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, subcategorySelected, listsubcategories, clearState } = props;

    const { createSubCategory, editSubCategory } = useSubcategoryStore();
    const { getSpecificsubcategoriesByCompany } = useSpecificSubcategoryStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [specificSubcategories, setSpecificSubcategories] = useState<any>([]);
    const [selected, setSelected] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [data, setData] = useState<Values>({
        id: subcategorySelected ? subcategorySelected.id :'',
        description: subcategorySelected ? subcategorySelected.description :'',
        name: subcategorySelected ? subcategorySelected.name :'',
        idspecificsubcategories: subcategorySelected ? subcategorySelected.idspecificsubcategories :'',
        status: subcategorySelected ? subcategorySelected.status :'',
    });

    useEffect(() => {
        if(subcategorySelected && specificSubcategories && !searchTimeout){
            const idspecificsubcategories = JSON.parse(subcategorySelected.idspecificsubcategories) || [];
            const subcategoriesSelected = specificSubcategories.filter(subcategory => idspecificsubcategories.includes(subcategory.id));
            setSelected(subcategoriesSelected || []);
        }
    },[subcategorySelected, specificSubcategories, !searchTimeout])

    useEffect(() => {
        getSpecificsubcategoriesByCompanyApi()
    },[])

    const getSpecificsubcategoriesByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getSpecificsubcategoriesByCompany(search);
            if(!response){
                setSpecificSubcategories([]);
                setLoadingdata(false);
                return false;
            }else{
                setSpecificSubcategories(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = specificSubcategories.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const isSelected = (row) => {
        return selected.some(item => item.id === row.id);
    };

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificsubcategoriesByCompanyApi(term)}, 1000)
        )
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        // if(!values.description) errors.description = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idspecificsubcategories = selected.map(subcategory => subcategory.id);

        const formData = {
            ...values,
            idspecificsubcategories: JSON.stringify(idspecificsubcategories)
        }

        if(subcategorySelected){
            const response:any = await editSubCategory(subcategorySelected.id, formData);
            if(response){
                listsubcategories && listsubcategories();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createSubCategory(formData);
            if(response){
                listsubcategories && listsubcategories();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={subcategorySelected ? 'Editar subfamilia' : 'Nueva subfamilia'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                            id="name"
                                            type="text" 
                                            name="name"
                                            fullWidth
                                            size="small"
                                            value={values.name}
                                            onChange={handleChange}
                                            error={errors.name && touched.name ? true : false}
                                            helperText={errors.name && touched.name ? errors.name : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                            id="description"
                                            type="text" 
                                            name="description"
                                            fullWidth
                                            size="small"
                                            value={values.description}
                                            onChange={handleChange}
                                            error={errors.description && touched.description ? true : false}
                                            helperText={errors.description && touched.description ? errors.description : ''}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                titlelabel={'Lineas'}
                                                columns={columns} 
                                                loading={loadingdata} 
                                                hasOptions
                                                rows={specificSubcategories || []}
                                                onRowClick={() => {}}
                                                selectAll={handleSelectAllClick}
                                                onCheckbox={onCheckbox}
                                                isSelected={isSelected}
                                                onSearch={onSearch}
                                                RowsPerPage={5}
                                                dense
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                    loadingConfirmText={loading}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}